import React, { useEffect, useState } from "react";
// import img1 from "../../Assets/images/cat-pic.jpg";
// import cleaning from "../../Assets/images/cleaning.jpg";
// import gym from "../../Assets/images/gym.jpg";
import noimage from "../../Assets/images/Image_not_available.png";

import { BiCheck } from "react-icons/bi";
import { api_url } from "../../Constants/web_services";
import { Link } from "react-router-dom";

const HomeServices = () => {
  const [companiesByServices, setCompaniesByServices] = useState([]);

  useEffect(() => {
    fetch(api_url + "/api/companiesbyservice")
      .then((response) => response.json())
      .then((data) => {
        // console.log('Fetched data:', data?.data?.company_services); // Log the fetched data for debugging
        setCompaniesByServices(data?.data?.company_services);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []); // Adding the empty dependency array ensures this runs only once


  const StarRating = ({ rating }) => {
    const fullStars = Math.floor(rating); // Number of full stars
    const emptyStars = 5 - fullStars; // Number of empty stars

    const starElements = [];

    // Add full star elements
    for (let i = 0; i < fullStars; i++) {
      starElements.push(
        <span key={i} className="fa fa-star" style={{ fontSize: "25px" }} />
      );
    }

    // Add empty star elements
    for (let i = 0; i < emptyStars; i++) {
      starElements.push(
        <span
          key={fullStars + i}
          className="fa fa-star text-022279"
          style={{ fontSize: "20px" }}
        />
      );
    }

    return <div className="sf-ow-pro-rating">{starElements}</div>;
  };
  return (
    <>
      <section className="site-bg-gray aon-feature-provider-area sf-curve-pos">
        <div className="container">
          {/*Title Section Start*/}
          <div className="section-head">
            <div className="row">
              <div className="col-lg-6 col-md-12">
                <span className="aon-sub-title">Popular Services</span>
                <h2 className="sf-title">Featured Services Providers</h2>
              </div>
              <div className="col-lg-6 col-md-12 d-flex">
                <div>
                  <h3>Revolutionary Software</h3>
                  <p>Transform industries with our innovative projects.</p>
                </div>
                <div>
                  <h3>Customized Excellence</h3>
                  <p>Tailored solutions that fit your goals perfectly.</p>
                </div>
                <div>
                  <h3>Tomorrow's Tech Today</h3>
                  <p>Future-proof projects that keep you ahead.</p>
                </div>
              </div>
            </div>
          </div>
          {/*Title Section End*/}

          <div className="section-content">
            <div className="row">
              {companiesByServices?.length > 0 &&
                companiesByServices?.slice(0, 3)?.map((compService, index) => (
                  <div className="col-md-4" key={index}>
                    {/* Individual company service card */}
                    <div className="item">
                      <div className="aon-ow-provider-wrap">
                        <div className="aon-ow-provider shine-hover">
                          <div className="aon-ow-top">
                            {/* Check mark icon */}
                            <div className="aon-pro-check">
                              <span>
                                <BiCheck />
                              </span>
                            </div>
                            {/* Heart icon for favorites */}
                            {/* <div className="aon-pro-favorite">
                              <Link href="#">
                                <AiOutlineHeart />
                              </Link>
                            </div> */}
                            {/* Company name and location */}
                            <div className="aon-ow-info">
                              <h4 className="aon-title s-18">
                                {/* Link to company profile */}
                                <Link
                                  href="profile-full.html"
                                  className="text-decoration-none fw-700"
                                >
                                  {compService.name}
                                </Link>
                              </h4>
                              <span>{compService?.office_location}</span>
                            </div>
                          </div>
                          <div className="aon-ow-mid">
                            {/* Company logo */}
                            <div className="aon-ow-media media-bg-animate">
                              {/* Link to company profile */}
                              <Link
                                to={`/profile/${compService.id}`}
                                className="shine-box"
                                style={{ width: "300px", height: "200px" }}
                              >
                                {/* Company logo image */}
                                <img
                                  src={
                                    compService.logo
                                      ? api_url + "/" + compService.logo
                                      : noimage
                                  }
                                  alt="1"
                                  style={{ width: "220px" }}
                                />
                              </Link>
                            </div>
                            {/* Company Services */}
                            <div className="d-flex justify-content-between">
                              <div className="aon-post-info">
                                <h4 className="aon-post-title s-18">
                                  <p className="text-decoration-none fw-700">
                                    Specialist in:
                                  </p>
                                </h4>
                              </div>
                              {compService?.services?.length > 0 &&
                                compService?.services
                                  ?.slice(0, 2)
                                  ?.map((service, index) => (
                                    <Link
                                      key={index}
                                      to={`/profile/${compService.id}`}
                                      className="aon-sub-title"
                                      style={{ width: "100px", height: "50px" }}
                                    >
                                      {service.service_name}
                                    </Link>
                                  ))}
                            </div>
                            {/* Company rating */}
                            <div className="aon-ow-pro-rating">
                              <StarRating rating={compService?.rating} />
                            </div>
                          </div>
                        </div>
                        {/* Request a quote button */}
                        <div className="aon-ow-bottom">
                          <Link
                            to={api_url + `/profile/${compService.id}`}
                            className="text-decoration-none"
                          >
                            Request A Quote
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeServices;
